module.exports = __webpack_public_path__ + "img/task888.10cbdf1d.png";